import { SnackbarItem } from '@george-labs.com/design-system';

import { uuid } from '@luna/utils';

import type { SnackItem } from './SnackItem';
import { useNotificationsState } from './useNotificationsState';

export interface OptionalIdSnackItem extends Omit<SnackItem, 'id'> {
    id?: string;
}

export const addSnackbarItem = ({
    id = uuid(),
    autoCloseable = SnackbarItem.AUTO_CLOSEABLE.ENABLED,
    ...item
}: OptionalIdSnackItem): void => {
    useNotificationsState.dispatchActions.addItem({ id, autoCloseable, ...item });
};
